<script lang="ts">
	import { onMount } from 'svelte';
	import { getClient, query } from 'svelte-apollo';
	import Mixtable from '../../components/Segments/Mix/Mixtable.svelte';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import { getSegmentsQuery } from '../../graphql/queries/segments';

	const client = getClient();
	const getSegmentsOp = query(client, { query: getSegmentsQuery });

	function refresh() {
		getSegmentsOp.refetch();
	}

	onMount(() => {
		refresh();
	});

	let isDentsu = false;
	/*$: {
		if ($userInfo.client !== undefined) {
			isDentsu = $userInfo.client.id === '1' || $userInfo.client.id === '7' ? true : false;
		}
	}*/
</script>

<AppContainer fluid>
	{#await $getSegmentsOp}
		<LoadingOverlay title="Loading..." spinner />
	{:then data}
		<svelte:component this={Mixtable} data={data.data.segments} {isDentsu} />
	{:catch e}
		{e}
	{/await}
</AppContainer>
